function TimeFormat(value) {
  const time = new Date(value);
  return `${time.getHours()}:${time.getMinutes()}`;
}
export default TimeFormat;
